module.exports = __webpack_public_path__ + "img/08王兰彩.5fd4b958.jpg";